import { Link } from 'react-router';
export function NotFoundPage() {
  return (
    <div className="empty-state">
      <div className="page-title">Page not found</div>
      <p>The address you followed does not exist in this portal.</p>
      <Link className="btn btn-primary btn-sm" to="/">Back to dashboard</Link>
    </div>
  );
}
